"use client"

import { usePathname } from "next/navigation"
import { useEffect, useRef } from "react"
import { useTracking } from "./tracking-context"

/**
 * Fires `page_view` on initial load and on every client-side route change.
 * Gated by the Admin `enabledEvents.page_view` flag inside pushEvent.
 *
 * NOTE: GTM's Google Tag (config) can also auto-emit a GA4 page_view on every
 * page. If both fire, GA4 will double-count. Coordinate with the ads manager:
 * either keep this ON and disable the Google Tag's automatic page_view, or keep
 * this OFF and let GTM own page_view. Server-side / Meta CAPI PageView relies on
 * this dataLayer push (the `page_view_stape` trigger), so ON is usually correct.
 */
export default function PageViewTracker() {
  const { trackPageView } = useTracking()
  const pathname = usePathname()
  const lastPath = useRef<string | null>(null)

  useEffect(() => {
    if (lastPath.current === pathname) return
    lastPath.current = pathname
    trackPageView(pathname || undefined)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  return null
}
